var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var MediaTypeController = /** @class */ (function () {
    function MediaTypeController() {
    }
    /*****************************************************************************************************
        * Is using route "api/mediaType" and http method "POST" to call the back-end.
    
        * @param {string[]} mediaTypes
        * @returns {string[]}
    ******************************************************************************************************/
    MediaTypeController.GetFileEndings = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaTypes
        });
    };
    return MediaTypeController;
}());
export { MediaTypeController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MediaTypeController.js.map